<template>
    <x-page title="Validation Rules">
        <template #header-actions>
            <x-create-button url="/admin/validation-rules/create" :disabled="isLoading" />
        </template>
        <x-table :headers="[
            'Nama',
            'Tipe',
            'Connected Forms',
            '',
        ]" :is-loading="isLoading">
            <tr v-for="(rule, index) in rules" :key="index">
                <td>
                    <router-link :to="`/admin/validation-rules/${rule.id}`" 
                        title="Klik untuk lihat detail">
                        {{ rule.label }}
                    </router-link>
                </td>
                <td>{{ rule.human_readable_type }}</td>
                <td>
                    <a href="javascript:;" @click.prevent="showEventModal(rule)">
                        Lihat detail ({{ rule.event_forms.length }})
                    </a>
                </td>
                <td>
                    <x-quick-edit-button :url="`/admin/validation-rules/${rule.id}/edit`"
                        :disabled="isLoading" />
                    <x-quick-delete-button @click="deleteResource(rule)"
                        :disabled="isLoading" />
                </td>
            </tr>
        </x-table>

        <pagination v-if="shouldRenderPagination" :pagination="meta" :query="filters" />
        <validation-rule-event-modal id="event-modal" :rule="highlightedRule" />
    </x-page>
</template>

<script>
import XCreateButton from '../../components/XCreateButton.vue'
import XQuickDeleteButton from '../../components/XQuickDeleteButton.vue'
import XQuickEditButton from '../../components/XQuickEditButton.vue'
import XPage from '../../components/XPage.vue'
import XTable from '../../components/XTable.vue'
import { deletePrompt, handleGeneralXhrError } from '../../helpers'
import PaginationMixin from '../../mixins/PaginationMixin'
import ValidationRuleEventModal from './ValidationRuleEventModal.vue'
export default {
    components: {
        ValidationRuleEventModal,
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
    },
    created() {
        this.fetchRules()
    },
    data() {
        return {
            highlightedRule: null,
            isLoading: false,
            rules: [],
        }
    },
    methods: {
        deleteResource(rule) {
            deletePrompt({
                name: rule.label,
                onConfirm: () => {
                    this.isLoading = true
                    const request = axios.delete(`/api/validation-rules/${rule.id}`)
                        .then(() => {
                            this.$notify({
                                type: 'success',
                                title: `Berhasil`,
                                text: `${rule.label} dihapus!`,
                            })
                            this.fetchRules()
                        })
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false
                    })
                },
            })
        },
        fetchRules() {
            this.isLoading = true
            const request = axios.get('/api/validation-rules', {
                params: {
                    with: [
                        'event_forms.event',
                    ],
                }
            }).then(response => {
                this.rules = response.data.data
                this.setMeta(response)
            })
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false
            })
        },
        showEventModal(rule) {
            this.highlightedRule = rule
            $('#event-modal').modal('show')
        },
    },
    mixins: [
        PaginationMixin,
    ],
}
</script>